import NavBar from '../components/navbar';
import Pusher from '../components/pusher';
import CampainCarousel from '../components/campaincarousel';
import GoldenHairClip from '../components/goldenhairclip';
import TopProducts from '../components/topproducts';
import TopCategories from '../components/topcategories';
//import InstagramPosts from '../components/instagram';
import OurDesignerStory from '../components/designer';
import Footer from '../components/footer';
import Header from '../components/header';
import AnimatedText from '../components/animatedtext';
import OurMission from '../components/mission';
import OurPerks from '../components/perks';
import Facts from '../components/facts';
import HeadQuarter from '../components/headquarter';
import B2BInvite from '../components/b2b';

import useDictionary from '../hooks/useDictionary';

import InstagramFeed from '../components/instagramtiles';
import Community from '../components/community';
//import BigPhoto from '../components/bigphoto';

//import AccessoriesImage from '../images/test/akcesoria-black-f.png';

export default function MainPage() {
/* <InstagramPosts /> */

    const dictionary = useDictionary();

    return (
        <>
        <NavBar />
        <Pusher />
        <div className="main-page">
            <CampainCarousel />
            <GoldenHairClip />

            <Header type="3" uptitle={dictionary.TOP_CATEGORIES} morehref="https://store.negativbrand.com/moretopproducts" moretitle={dictionary.GO_TO_STORE}>{dictionary.WHAT_WE_DO}</Header>
            <TopCategories />
            
            <Header type="3" uptitle={dictionary.BESTSELLERS} morehref="https://store.negativbrand.com/moretopproducts" moretitle={dictionary.SHOW_MORE}>{dictionary.TOP_PRODUCTS}</Header>
            <TopProducts />
            

            <Header type="3" uptitle={dictionary.DETAILS_MATTER}>{dictionary.WHAT_SPECIAL}</Header>
            
            <OurPerks />
            
            <div style={{padding: "30px"}}>
                <AnimatedText text="<s>#NGV</s> Start dress like <s>you are already famous!</s>" effect="typing" speed={25} startOnView={true} cursor={true} />
            </div>
            <B2BInvite />
            <OurMission />
            <div style={{paddingBottom: "40px", paddingTop: "10px" }}>
                <AnimatedText text="<s>#NGV</s> Premium urban sport <s>independent style</s>" effect="typing" speed={25} startOnView={true} cursor={true} />
            </div>
            
            <OurDesignerStory />
            
            <Header type="3" uptitle={dictionary.NGV_COMMUNITY}>{dictionary.APPRECIATE_TRUST}</Header>            
            <Community />

            <HeadQuarter />

            <Header type="3" uptitle="@negativ_official" morehref="https://www.instagram.com/negativ_official/" moretitle={dictionary.SHOW_PROFILE}>Instagram best shoots</Header>
            <InstagramFeed title="Nasze Instagram" />

            <Facts />
            
            <Footer />
        </div>
        </>
    )

}
